import dayjs from "dayjs";

export default function isUnderEighteen(date) {
  const now = dayjs(new Date());
  const dob = dayjs(date);
  return now.diff(dob, "year") < 18;
}
